import View from 'view/view'
import windowView from 'shared/view/window'
import locationService from 'service/location'

const TertiaryNavigationView = View.extend({
    events: {
        change: '_onChange',
    },

    el: '.js-dropdown-navigation',

    initialize() {
        // Only relevant for mobile because the tertiary
        // navigation turns from links into a dropdown
        if (!windowView.isMobile()) {
            return
        }

        this.selectedUrl = this.$el.val()
    },

    _onChange() {
        const newUrl = this.$el.val()

        if (this.selectedUrl !== newUrl) {
            this.selectedUrl = newUrl
            this._changePage(newUrl)
        }
    },

    _changePage(url) {
        locationService.loadUrl(url)
    },
})

export default TertiaryNavigationView
